import { Store } from "@material-ui/icons";
import Axios, { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";
import { FixMeLater } from "types/FixMeLaterType";
import { getApiConfig } from "../../config/apiConfig";
import { adalApiFetch } from "../../config/azureConfig";
import {
    GET_DASHBOARD_LAYOUTS,
    GET_DASHBOARD_LAYOUTS_BY_IDS,
    SET_DASHBOARD_LAYOUT,
    DELETE_DASHBOARD_LAYOUT, GET_CURRENT_DASHBOARD_LAYOUT, CLEAR_CURRENT_DASHBOARD_LAYOUT
} from "../constants/action-types";


const API_CONFIG = getApiConfig();

type Dispatch =
    (data: { type: string, payload: FixMeLater }) => {}


/**
 * Get all dashboard layouts
 * @param {Function} callback 
 */
export const getDashboardLayouts = (callback: ((success: boolean) => void)) => (dispatch: Dispatch) => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/dashboard-layout`, {
        method: "get"
    })
        .then((res: AxiosResponse) => {
            dispatch({
                type: GET_DASHBOARD_LAYOUTS,
                payload: res.data
            });

            callback(true);
        }).catch((error: Error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
};

/**
 * Get dashboard layouts matching given ids
 * @param {string[]} layoutIds 
 * @param {Function} callback 
 */
export const getDashboardLayoutsByIds = (layoutIds: string[], callback: ((success: boolean) => void)) => (dispatch: Dispatch) => {
    const dashboardLayoutIds = {
        DashboardIds: layoutIds
    }
    adalApiFetch(Axios, `${API_CONFIG.URL}/dashboard-layout?forIds=true`, {
        method: "post",
        data: dashboardLayoutIds
    })
        .then((res: AxiosResponse) => {
            dispatch({
                type: GET_DASHBOARD_LAYOUTS_BY_IDS,
                payload: res.data
            });

            callback(true);
        }).catch((error: Error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
};

/**
 * Create a dashboard layout. Updates the layout if the id is used
 * @param {DashboardLayout} dashboardLayout 
 * @param {Function} callback 
 */
export const setDashboardLayout = (dashboardLayout: FixMeLater, callback: (success: boolean) => void) => (dispatch: Dispatch) => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/dashboard-layout`, {
        method: "post",
        data: dashboardLayout
    })
        .then((res: AxiosResponse) => {
            dispatch({
                type: SET_DASHBOARD_LAYOUT,
                payload: res.data
            });

            callback(true);
        }).catch((error: Error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
};

/**
 * Delete the specified dashboard layout
 * @param {string} layoutId 
 * @param {Function} callback 
 */
export const deleteDashboardLayout = (layoutId: string[], callback: (success: boolean) => void) => (dispatch: Dispatch) => {
    adalApiFetch(Axios, `${API_CONFIG.URL}/dashboard-layout/delete/${layoutId}`, {
        method: "delete"
    })
        .then((_: AxiosResponse) => {
            dispatch({
                type: DELETE_DASHBOARD_LAYOUT,
                payload: layoutId
            });

            callback(true);
        }).catch((error: Error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
};


export const getCurrentDashboardLayout = (layoutId: string, callback: (success: boolean) => void) => (dispatch: Dispatch) => {
    const dashboardLayoutIds = {
        DashboardIds: [layoutId]
    }
    adalApiFetch(Axios, `${API_CONFIG.URL}/dashboard-layout?forIds=true`, {
        method: "post",
        data: dashboardLayoutIds
    })
        .then((res: AxiosResponse) => {
            dispatch({
                type: GET_CURRENT_DASHBOARD_LAYOUT,
                payload: res.data
            });

            callback(true);
        }).catch((error: Error) => {
            console.log(`Exception Occurred: ${error.message}`);
            callback(false);
        })
};

export const clearCurrentDashboardLayout = (callback: (success: boolean) => void) => (dispatch: Dispatch) => {
    dispatch({
        type: CLEAR_CURRENT_DASHBOARD_LAYOUT,
        payload: null
    });

    callback(true);
};

